import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-file",
  "use": "icon-file-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-file\"><defs><style></style></defs><path d=\"M213.34 0H640l298.66 298.66V896q0 53.002-37.499 90.501T810.66 1024H213.32q-53.003 0-90.501-37.499T85.319 896V128q0-53.002 37.5-90.501T213.319 0zm341.32 384V85.34H213.32q-18.002 0-30.331 12.33T170.659 128v768q0 18.002 12.33 30.33t30.33 12.33h597.34q18.003 0 30.332-12.33T853.32 896V384H554.66zm263.332-85.34L640 120.668V298.66h177.992z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol